import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}
const CardList = ({ children }: Props) => {
  return (
    <ul role='list' className='divide-y divide-gray-100'>
      {' '}
      {children}
    </ul>
  );
};
export default CardList;
